module.exports = __webpack_public_path__ + "img/ICBC-PERU-BANK.cf4f8335.svg";